/**
 * Which of the five things /me/profile can be showing.
 *
 * Extracted from the route because the branch that matters most cannot be
 * reached from a test of the page: the suite renders to a string with a seeded
 * query cache, which can hold data but not a failed request.
 *
 * The one to get right is `error`. `useProfile` catches a 404 and answers null
 * — that is "signed in, never finished the wizard". Every OTHER failure leaves
 * `data` undefined, which looks identical if the check is `!data`, and sending
 * a set-up coach to the wizard is destructive rather than merely wrong: the
 * wizard has nothing to seed from, and `PUT /me/profile` replaces the stored
 * record, so finishing it with a blank phone field erases the phone that was
 * there. A failed request must say so and change nothing.
 */
export type ProfileBranch = "loading" | "signedOut" | "error" | "setup" | "form";

export function profileBranch(q: {
  ready: boolean;
  signedIn: boolean;
  isError: boolean;
  /** null = no profile yet (the 404); undefined = no answer yet. */
  profile: unknown | null | undefined;
}): ProfileBranch {
  if (!q.ready) return "loading";
  if (!q.signedIn) return "signedOut";
  if (q.isError) return "error";
  if (q.profile === null) return "setup";
  if (q.profile === undefined) return "loading";
  return "form";
}
